import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IActionState } from '../../utils/state-utils/action-state.model';

export abstract class A11yService {
  abstract scalingFactor$: Observable<number>;
  public abstract getFontScale(): number;
  public abstract setFontScale();
  public abstract announceAndFocus(
    text: string,
    focusElement?,
    labelNSComponent?,
    accessibilityRole?
  ): void | string;
  public abstract getFontScaleAndroid(): number;
  public abstract setFocus(focusElement);
  public abstract handlePullToRefresh<T extends IActionState>(options: {
    pullRefresh: unknown; // The pull-to-refresh component instance
    announcer: unknown; // The label component used for accessibility announcements
    actionStates: Observable<T>[]; // Array of action state observables to wait for
    dispatchActions: (store: Store) => void; // Function to dispatch actions
    store: Store; // The store instance
    liveRegion?: string; // Optional live region type for Android
  }): void;
}
